import { useParams } from "react-router-dom";
import PageView from "./PageView"
import createFormContext from '../../context/formContext'
import { ModalProvider } from "../modal/useModalDialog";

const { FormStateProvider, useStore } = createFormContext({
    id: "",
    loaded: false,
    savedOn: "",
});

export { useStore, FormStateProvider };

const { FormStateProvider: MessageProvider, useStore: useMessage } = createFormContext({
    show: false,
    title: 'ok',
    message: 'Ok',
    type: 'success'
});

export { useMessage, MessageProvider };


const Page = ({ type, options, dispatch = (action, data) => { } }) => {

    /*
     * A route with `remountOnId` starts a fresh page for every id: the router
     * keeps the page mounted when only the id changes, and a page that loads
     * or transitions once on mount would go on showing the previous record.
     * A work queue walking from one inbox document to the next needs it
     * (task 38.04).
     */
    const { id } = useParams()
    const key = options?.remountOnId ? id : undefined

    return (
        <FormStateProvider key={key}>
            <MessageProvider>
                <ModalProvider>
                    <PageView type={type} options={options} dispatch={dispatch} />
                </ModalProvider>
            </MessageProvider>
        </FormStateProvider>
    )

}

export default Page